import styled from "styled-components";
import { type DisplayProps, type SpaceProps, display, space } from "styled-system";
import { theme } from "../theme/toyotaTheme";

export const Separator = styled.hr.attrs(() => ({
    className: "separator",
}))<SpaceProps & DisplayProps>`
    width: 100%;
    height: 1px;
    border: none;
    border-bottom: 1px solid;
    border-color: ${theme.colors.grey2};
    ${display};
    ${space};
`;

export default Separator;
